import React, { useState, useEffect } from 'react';
import EditEventStyles from './EditBenefits.module.css';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';

const EditBenefits = () => {
  const location = useLocation();
  const data = location.state;
  console.log(data);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [eventData, setEventData] = useState({
    benefitsDesc: '',
  });

  const count = useSelector((state) => state.globalData.notificationCount);

  useEffect(() => {
    // Update the state with initial values from data
    setEventData({
      benefitsDesc: data.benefitsDesc,
    });
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEventData({ ...eventData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const eventResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/benefits/updateBenefits/${data.benefitsId}`,
        eventData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // console.log('Benefits Updated.');
      // console.log(eventResponse);

      dispatch(fetchNotifications());

      dispatch(
        setNotificationCount({
          count: count + 1,
        })
      );

      alert('Benefits Updated.');
      navigate('/benefits');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={EditEventStyles.editEventMain}>
      <div className={EditEventStyles.editEventContent}>
        <form action="" className={EditEventStyles.editEventForm} onSubmit={handleSubmit}>
         
          <label className={EditEventStyles.editEventFormLabel}>Benefits</label>
          <textarea
            className={EditEventStyles.editEventFormDesc}
            value={eventData.benefitsDesc}
            name="benefitsDesc"
            onChange={handleInputChange}
          />
          <Button variant="contained" type="submit" className={EditEventStyles.saveChanges}>
            Save changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default EditBenefits
